import { connect } from 'react-redux';
import AttributionLandingPage from './AttributionLandingPage';

const mapStateToProps = state => {
    return { userData: state.user.data };
};

export default connect(mapStateToProps)(AttributionLandingPage);
